export const accordionItems = {
  userName: "Maurice Umoh",
  current: 150,
  goal: 105,
  streak: 4,
  content: {
    medicalSnapshot: {
      conditions: ["Prediabetes", "Hypertension"],
      allergies: ["Penicillin", "Shellfish"],
      activeMeds: ["Metformin"],
      refills: 2,
    },
    wellnessStats: {
      avgWeekLoss: 1.6,
      calorieBudget: 1800,
      workouts: 12,
      target: 16,
    },
  },
};
